/**
 * HTML-to-text helpers, shared so word count, reading time and structured data
 * can never disagree.
 *
 * Auto-imported on both client and server via Nuxt's utils/ directory.
 */

/** Strip tags, scripts, comments and entities from HTML, leaving collapsed text. */
export function htmlToText(html: string): string {
  return html
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, ' ')
    .replace(/<!--[\s\S]*?-->/g, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&(?:amp|lt|gt|quot|apos|#39);/gi, ' ')
    .replace(/&#\d+;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

/**
 * Word count of an HTML document.
 *
 * Note this counts words in the *text*. Structured data previously reported
 * `content.length / 5`, i.e. one fifth of the raw HTML character count including
 * every tag and class attribute — both materially inflated and a non-integer,
 * which schema.org's `wordCount` (an Integer) does not accept.
 */
export function countWords(html: string): number {
  const text = htmlToText(html)
  return text ? text.split(' ').length : 0
}

/** Reading time in whole minutes, floored at 1. */
export function readingTimeMinutes(html: string, wordsPerMinute = 200): number {
  return Math.max(1, Math.ceil(countWords(html) / wordsPerMinute))
}
